// PurchaseSuccess.js
import {useSearchParams, useNavigate, Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useAuth} from "../contexts/authContext";

export default function PurchaseSuccess() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const kind = sp.get("kind");
  const prepaidTotal = sp.get("prepaid_total");
  const historyId = sp.get("history_id");
  const expiry = sp.get("expiry");
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="p-6 max-w-md mx-auto">
          <h1 className="text-xl font-bold mb-2">결제가 완료되었습니다 🎉</h1>
          <div className="text-sm text-gray-300">
            유형: {kind}
            {prepaidTotal && <div>충전 잔여: {prepaidTotal}회</div>}
            {expiry && <div>만료일: {expiry}</div>}
          </div>
          <button
            className="mt-4 px-4 py-2 rounded bg-blue-600 text-white"
            onClick={() => navigate("/mypage")}
          >
            마이페이지로 이동
          </button>
        </div>
      </div>
  );
}